import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {MonthViewDay, WeekDay} from '../../models/time-and-attendance.interfaces';

@Pipe({
  name: 'gpDayOfWeek',
  pure: false
})
export class DayOfWeekPipe implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  public transform(value: MonthViewDay | WeekDay): string {
    let day: string;
    switch (value.dayOfWeek) {
      case 0:
        day = this.translate.instant('PAYROLL_PREPARE.Sun');
        break;
      case 1:
        day = this.translate.instant('PAYROLL_PREPARE.Mon');
        break;
      case 2:
        day = this.translate.instant('PAYROLL_PREPARE.Tue');
        break;
      case 3:
        day = this.translate.instant('PAYROLL_PREPARE.Wed');
        break;
      case 4:
        day = this.translate.instant('PAYROLL_PREPARE.Thu');
        break;
      case 5:
        day = this.translate.instant('PAYROLL_PREPARE.Fri');
        break;
      case 6:
        day = this.translate.instant('PAYROLL_PREPARE.Sat');
        break;
      default:
        day = '';
    }
    return day;
  }
}
